import { AssessmentState, ComponentBusinessId, Section } from '@cambridgeassessment/lib-ee-commons';
import qs from 'qs';
import { SortingParams } from '../../pages/Content/MalpracticeReports/components/ReportTable/ReportTable';
import { RmaErrors, SearchValues } from '../../types/RmaErrors';
import { PagedFetchResult } from '../httpHelpers/pagedFetch';
import * as submitter from '../httpHelpers/submitter';
import _ from 'lodash';

const RMA_REPORT_PAGE_SIZE = 20;

export const getSectionsByParams = (
  businessUnitId: ComponentBusinessId['businessUnitId'],
  searchValue: SearchValues,
  nextUrl?: string,
  assessmentState?: AssessmentState[],
  sortingParams?: SortingParams<RmaErrors>,
): Promise<PagedFetchResult<Section>> => {
  const noEmptyStrings = _.pickBy(searchValue, (v) => v !== '');
  const { seriesId, assessmentCode, componentNumber, centreId, learnerNumber, errorType } = noEmptyStrings;

  const queryParams = qs.stringify({
    assessmentCode,
    componentNumber,
    centreId,
    learnerNumber,
    errorType,
    assessmentState,
    fieldName: sortingParams?.fieldName,
    order: sortingParams?.order,
  });

  return submitter.pagedFetch(
    `v1/businessUnit/${businessUnitId}/series/${seriesId}/sections-by-query?${queryParams}`,
    nextUrl,
    { pageSize: RMA_REPORT_PAGE_SIZE },
  );
};

export const updateSectionsAssessmentState = (
  businessUnitId: ComponentBusinessId['businessUnitId'],
  { seriesId, assessmentCode, componentNumber, centreId, learnerNumber, errorType }: SearchValues,
): Promise<void> => {
  return submitter.patch(`v1/businessUnit/${businessUnitId}/series/${seriesId}/sections-assessment-state`, {
    assessmentCode,
    componentNumber,
    centreId,
    learnerNumber,
    errorType,
    assessmentState: [AssessmentState.FAILED_TO_SEND_FOR_ASSESSMENT],
  });
};
